import { Button, Card, Flex, Text } from '@wyz/ui';
import { Trans, useI18n } from '~/common/context';
import { CustomerUtils } from '~/connect/helpers';
import { useCustomerFormPrivileges } from '~/connect/hooks';
import { CustomerFormStep } from '~/connect/types';

type Props = {
  stepKey: CustomerFormStep;
  activeStep: number;
  isLoading: boolean;
  onPrevious: () => void;
  customerLevel: number;
  entityName?: string;
};
export default function CustomersCreateFormActions({
  customerLevel,
  stepKey,
  activeStep,
  onPrevious,
  isLoading,
  entityName,
}: Props) {
  const { t } = useI18n();
  const CustomerFormPrivileges = useCustomerFormPrivileges({
    level: customerLevel,
  });
  return (
    <Card className='sticky container-lg row'>
      <Card.Body>
        <Flex justifyContent={'between'}>
          <Button
            type='button'
            id='previous'
            variant='link'
            disabled={isLoading || activeStep === 0}
            onClick={onPrevious}
          >
            <Trans i18nKey='app.common.button.previous' />
          </Button>
          <Flex alignItems='center' className='space-x-2'>
            <Text heading='sm' color='secondary'>
              {entityName}
            </Text>
            <Text heading='sm' color='secondary-gray'>
              <Trans
                i18nKey='app.common.step_value'
                values={{
                  stepNumber: activeStep + 1,
                  stepName: t(CustomerUtils.getStepLabelByKey(stepKey)),
                }}
              />
            </Text>
            <Button
              type='submit'
              id='submit'
              variant='primary'
              isLoading={isLoading}
            >
              <Trans
                i18nKey={
                  CustomerUtils.getAuthorizedSteps(CustomerFormPrivileges)
                    .length -
                    1 !==
                  activeStep
                    ? 'app.common.buttons.continue'
                    : 'app.entity.form.create_submit'
                }
              />
            </Button>
          </Flex>
        </Flex>
      </Card.Body>
    </Card>
  );
}
